(function () {
  function initCarousel(root, options) {
    const slides = Array.from(root.querySelectorAll(options.slideSelector));
    const dots = Array.from(root.querySelectorAll(options.dotSelector));
    if (slides.length < 2) return;

    let index = 0;
    const activeSlide = options.activeSlideClass;
    const activeDot = options.activeDotClass;

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle(activeSlide, i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle(activeDot, i === index);
        if (dot.hasAttribute('aria-selected')) {
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        }
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goTo(i));
    });

    let startX = 0;
    root.addEventListener(
      'touchstart',
      (event) => {
        startX = event.changedTouches[0]?.clientX || 0;
      },
      {passive: true},
    );
    root.addEventListener(
      'touchend',
      (event) => {
        const endX = event.changedTouches[0]?.clientX || 0;
        const delta = endX - startX;
        if (delta > 40) goTo(index - 1);
        else if (delta < -40) goTo(index + 1);
      },
      {passive: true},
    );

    window.setInterval(() => goTo(index + 1), 5000);
  }

  document.querySelectorAll('[data-mandira-hero]').forEach((root) => {
    initCarousel(root, {
      slideSelector: '.hero-slide',
      dotSelector: '.hero-slide-dot',
      activeSlideClass: 'hero-slide--active',
      activeDotClass: 'hero-slide-dot--active',
    });
  });

  document.querySelectorAll('[data-mandira-featured]').forEach((root) => {
    initCarousel(root, {
      slideSelector: '.featured-banner-slide',
      dotSelector: '.featured-banner-dot',
      activeSlideClass: 'featured-banner-slide--active',
      activeDotClass: 'featured-banner-dot--active',
    });
  });

  document.querySelectorAll('[data-home-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    const isCategories = root.classList.contains('home-carousel--categories');
    const isArrivals = root.classList.contains('home-carousel--arrivals');
    const loops =
      isCategories || isArrivals || root.hasAttribute('data-carousel-autoplay');
    /* Categories + New Arrivals carousel on both desktop and mobile */
    const autoplay = loops || root.hasAttribute('data-carousel-autoplay');
    let timer = null;
    let paused = false;

    function cardStep() {
      const card = track.querySelector('.home-carousel-card, .category-card');
      if (!card) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function updateNav() {
      const max = maxScroll();
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= max - 2;
      root.classList.toggle('home-carousel--at-start', atStart);
      root.classList.toggle('home-carousel--at-end', atEnd);

      if (loops) {
        if (prev) prev.disabled = max <= 2;
        if (next) next.disabled = max <= 2;
        return;
      }

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function scrollByStep(direction) {
      const step = cardStep();
      const max = maxScroll();
      if (max <= 2) return;

      let nextLeft = track.scrollLeft + direction * step;
      if (loops) {
        if (direction > 0 && track.scrollLeft >= max - 2) {
          nextLeft = 0;
        } else if (direction < 0 && track.scrollLeft <= 2) {
          nextLeft = max;
        }
      }

      track.scrollTo({left: nextLeft, behavior: 'smooth'});
    }

    function startAutoplay() {
      if (!autoplay || timer) return;
      timer = window.setInterval(() => {
        if (paused || document.hidden) return;
        scrollByStep(1);
      }, 4000);
    }

    function stopAutoplay() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    prev?.addEventListener('click', () => {
      scrollByStep(-1);
      if (autoplay) {
        stopAutoplay();
        startAutoplay();
      }
    });
    next?.addEventListener('click', () => {
      scrollByStep(1);
      if (autoplay) {
        stopAutoplay();
        startAutoplay();
      }
    });

    track.addEventListener('scroll', updateNav, {passive: true});
    window.addEventListener('resize', updateNav, {passive: true});

    if (autoplay) {
      root.addEventListener('mouseenter', () => {
        paused = true;
      });
      root.addEventListener('mouseleave', () => {
        paused = false;
      });
      root.addEventListener('focusin', () => {
        paused = true;
      });
      root.addEventListener('focusout', () => {
        if (!root.contains(document.activeElement)) paused = false;
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      startAutoplay();
    }

    updateNav();
  });
})();
